<template>
  <form>
      <div class="row q-col-gutter-md">
        <div class="col col-xs-12 col-md-6 col-lg-6">
              <q-select
                  v-model="TestimonialObj.user_id"
                  :options="users"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="500"
                  option-value="id"
                  option-label="name"
                  emit-value
                  map-options
                  clearable
                  :label="$t('testimonials.table_titles.user')"
                  :error="TestimonialObj.errors.has('user_id')"
                  color="input-color"
                  @filter="filterUsers"
              >
                  <template v-slot:option="scope">
                      <q-item
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          style="border-bottom:1px solid #999"
                          @click="grabUser(scope.opt)"
                      >
                          <q-item-section top>
                              <q-item-label lines="1">
                                  <span class="text-green">{{ scope.opt.id }} - </span>
                                  <span
                                      class="text-weight-medium text-uppercase">{{ scope.opt.name }}</span>
                              </q-item-label>
                              <q-item-label caption lines="1">
                                  {{ scope.opt.email }}
                              </q-item-label>
                              <q-item-label lines="1" class="text-body2 text-weight-bold text-primary">
                                  <span>{{ scope.opt.mobile }}</span>
                              </q-item-label>
                          </q-item-section>
                      </q-item>
                  </template>
                  <template v-slot:no-option>
                      <q-item>
                          <q-item-section class="text-grey">
                              No User Found!
                          </q-item-section>
                      </q-item>
                  </template>
              </q-select>
        </div> <!-- USER -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
            <q-input
                v-model="TestimonialObj.alias"
                :label="$t('testimonials.table_titles.alias')"
                :error="TestimonialObj.errors.has('alias')"
                :error-message="TestimonialObj.errors.get('alias')"
                color="input-color"
            />
        </div>  <!-- ALIAS -->
        <div class="col col-12">
            <q-input
                v-model="TestimonialObj.link"
                :label="$t('testimonials.table_titles.link')"
                :error="TestimonialObj.errors.has('link')"
                :error-message="TestimonialObj.errors.get('link')"
                color="input-color"
            />
        </div>  <!-- LINK -->
        <div class="col-12">
            <q-input
                outlined
                :label="$t('testimonials.table_titles.comment')"
                v-model="TestimonialObj.comment"
                type="textarea"
            />
        </div> <!-- Comment -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
              <q-input v-model="TestimonialObj.published_at"
                       :label="$t('testimonials.table_titles.published_at')"
                       color="input-color"
              >
                  <template v-slot:prepend>
                      <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                          <q-popup-proxy ref="qDateStart" transition-show="scale" transition-hide="scale">
                              <q-date v-model="TestimonialObj.published_at"
                                      mask="YYYY-MM-DD HH:mm"
                                      today-btn
                                      @input="() => $refs.qDateStart.hide()"
                              />
                          </q-popup-proxy>
                      </q-icon>
                  </template>

                  <template v-slot:append>
                      <q-icon name="fa fa-clock" class="cursor-pointer">
                          <q-popup-proxy transition-show="scale" transition-hide="scale">
                              <q-time v-model="TestimonialObj.published_at" mask="YYYY-MM-DD HH:mm" format24h>
                                  <div class="row items-center justify-end">
                                      <q-btn v-close-popup label="Set" color="primary" flat />
                                  </div>
                              </q-time>
                          </q-popup-proxy>
                      </q-icon>
                  </template>
              </q-input>
        </div> <!-- Published at -->
        <div class="col col-xs-12 col-sm-6 col-md-4">
              <p class="text-caption q-pb-xs" style="margin:0">{{$t('testimonials.table_titles.pinned')}}</p>
              <q-toggle
                  v-model="TestimonialObj.is_pinned"
                  checked-icon="fa fa-check"
                  color="green"
                  :label="TestimonialObj.is_pinned ? $t('testimonials.yes') : $t('testimonials.no')"
                  unchecked-icon="fa fa-times"
              />
        </div> <!-- Pinned -->
        <div class="col col-xs-12 col-sm-6 col-md-4">
              <p class="text-caption q-pb-xs" style="margin:0">{{$t('testimonials.table_titles.show_photo')}}</p>
              <q-toggle
                  v-model="TestimonialObj.show_photo"
                  checked-icon="fa fa-check"
                  color="green"
                  :label="TestimonialObj.show_photo ? $t('testimonials.yes') : $t('testimonials.no')"
                  unchecked-icon="fa fa-times"
              />
        </div> <!-- Show photo -->
      </div>
    </form>
</template>

<script>

import User from "Modules/User/resources/models/User"

export default {
  name: 'Form',
  model: {
    prop: 'TestimonialObj',
    event: 'change'
  },
  props: {
    TestimonialObj: {
      type: Object,
      required: true
    }
  },
  computed: {},
  data() {
    return {
        genders: [
            {label: 'Male', value: 'M', icon: 'fa fa-male', color: 'blue'},
            {label: 'Female', value: 'F', icon: 'fa fa-female', color: 'pink'},
            {label: 'Other', value: 'O', icon: 'fa fa-genderless', color: 'purple'},
        ],
        users: [],
        foreColor: '',
        backColor: '',
    }
  },
  methods: {
      color (cmd, name) {
          const edit = this.$refs.editor
          edit.caret.restore()
          edit.runCmd(cmd, name, true)
          edit.focus()
      },
      filterUsers(val, update, abort) {
          if (val.length < 3) {
              abort()
              return
          }
          User.list(`q=${val}`).then(response => {
              this.stringOptions = response
              update(() => {
                  this.users = this.stringOptions
              })
          }).catch(data => {
              abort()
          })
      },
      grabUser(user) {
          this.selectedUser = user
          this.TestimonialObj.user_id = user.id
      },
  },
  components: {},
}
</script>

<style scoped>

</style>
